var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('h1',{staticClass:"text-center"},[_vm._v("Not Found.")]),_c('p',{staticClass:"text-center"},[_vm._v("We couldn't find the page you were looking for.")])])}
var staticRenderFns = []

export { render, staticRenderFns }